import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { isEqual } from "lodash-es"
import { useDispatch, useSelector } from "react-redux"
import {
  getStatusCounts,
  getStatusesToHide,
  hideStatus,
  showStatus,
  STATUS_FILTER_OPTIONS,
} from "reduxSlices/surveyRecipientTableSlice"
import { Checkbox } from "shared/checkboxes"

const DeliveryStatusList = ({ className = "" }) => {
  const dispatch = useDispatch()

  const statusesToHide = useSelector(getStatusesToHide, isEqual)
  const statusCounts = useSelector(getStatusCounts, isEqual)

  const isStatusVisible = (value) => !statusesToHide.includes(value)

  const toggleStatusVisibility = (value) => () => {
    const updateFunction = isStatusVisible(value) ? hideStatus : showStatus

    dispatch(updateFunction(value))
  }

  return (
    <div className={clsx(className, "flex flex-col gap-2")}>
      {
        STATUS_FILTER_OPTIONS.map(({ label, value }) => (
          <div
            key={value}
            className="flex gap-2 items-center p-2 rounded-md border border-lightgray-3 cursor-pointer"
            onClickCapture={toggleStatusVisibility(value)}
          >
            <div className="grow flex items-center gap-1">
              <span className="text-sm font-medium">{label}</span>
              <span className="text-xs text-dark"> ({statusCounts[value] ?? 0})</span>
            </div>
            <Checkbox
              className="shrink-0"
              value={isStatusVisible(value)}
              onChange={toggleStatusVisibility(value)}
            />
          </div>
        ))
      }
    </div>
  )
}

DeliveryStatusList.propTypes = {
  className: types.string,
}

export default DeliveryStatusList
